module.exports = __webpack_public_path__ + "static/img/W020211231398298104137@2x.12fe1e4e.png";